import * as types from '@/store/mutation-types';
import MaskView from '@/components/common/MaskView.vue';
import ConfirmDialog from '@/components/common/Confirm.vue';
import settings from '@/utils/settings';
import Utils from '@/utils/Utils';
import Config from '@/utils/Config';
import balance from '@/utils/balance';
import axios from '@/service/interceptor';

export default {
    name: 'Header',
    components: {
        MaskView,
        ConfirmDialog
    },
    data() {
        return {
            blockURL: Config.BlockURL,
            isRouterAlive: true,
            lang: localStorage.getItem('lang') || 'en',
            host: Utils.getHostByCode(
                localStorage.getItem('host') || undefined
            ),
            userId: '',
            hostArray: settings.HostArray,
            showList: -1,
            exportIndex: '',
            logoutstatus: false,
            logoutstatusConfirm: false,
            Config,
            confirmViewType: 'logout',
            confirmView: false,
            maskView: false,
            exportDialog: false,
        };
    },
    mounted() {
        const outRoutes = ['Login', 'Reg', 'GetToken'];
        if (
            Config.CenterTrade &&
            !this.user.email &&
            !outRoutes.includes(this.currentRouteName)
        ) {
            return this.$router.push('/Login');
        }
        return this.initUser();
    },
    computed: {
        currentRouteName() {
            return this.$route.name;
        },
        currAccountIndex() {
            return this.$store.state.currAccountIndex;
        },
        user() {
            return this.$store.state.user;
        },
        accountList() {
            return this.$store.state.accountList;
        },
        webContent() {
            return this.$store.state.webContent;
        },
        inviterLink() {
            return `${location.host}/Register?inviter=${this.userId}`;
        }
    },
    watch: {
        currAccountIndex(n, o) {
            const self = this;
            if (n !== o && self.accountList && self.accountList[n]) {
                self.userId = self.accountList[n].userid;
            }
        },
        accountList(n, o) {
            const self = this;
            if (
                n !== o &&
                self.accountList &&
                self.accountList[self.$store.state.currAccountIndex]
            ) {
                const currAccountIndex = self.$store.state.currAccountIndex;
                self.userId = self.accountList[currAccountIndex].userid;
            }
        }
    },
    methods: {
        changeLanguage(language) {
            localStorage.setItem('lang', language);
            location.reload();
        },
        ok() {
            this.maskView = true;
            this.logoutstatus = false;
            this.logoutstatusConfirm = true;
            // this.confirmViewType = type;
        },
        cancel() {},
        logout() {
            if (Config.CenterTrade) {
                this.$store.commit(types.LOGOUT);
                localStorage.setItem('session', '{}');
                this.$router.push('/Login');
            } else {
                this.logoutstatus = true;
            }
        },
        hideLogoutDialog() {
            const self = this;
            self.logoutstatusConfirm = false;
            self.maskView = false;
        },
        hideMaskView() {
            const self = this;
            self.maskView = false;
            self.exportDialog = false;
        },
        goto(path) {
            if (!this.$store.getters.currAccount) {
                return this.$router.push('/Register');
            }
            return this.$router.push(path);
        },
        refresh() {},
        openWindow(url) {
            window.open(url, '_blank');
        },
        changeHost(code) {
            if (this.host.code !== code) {
                window.localStorage.setItem('host', code);
                window.location.href = window.location.href;
            }
        },
        async initUser() {
            const self = this;
            if (
                self.$store.state.accountList &&
                self.$store.state.accountList.length > 0
            ) {
                const AccountList = self.$store.state.accountList;
                self.accountlist = AccountList;
                const currAccountIndex = self.$store.state.currAccountIndex;
                const currUser = AccountList[currAccountIndex];
                self.userId = currUser.userid;
                const {data:{inviter}={}} = await axios.post(`${settings.SERVER_PREFIX}/me`, {
                    cmd: 'getUserInviter',
                    userid: this.$store.getters.currAccount.userid,
                });
                this.$store.commit(types.EDIT_ACCOUNT, {...currUser, inviter});
            }
        },
        selectAccount(index) {
            const self = this;
            self.$store.commit(types.SELECT_ACCOUNT, index);
            this.$router.go();
            self.userId =
                self.$store.state.accountList[
                    self.$store.state.currAccountIndex
                ].userid;
            // window.location.href = window.location.href
        },
        copyToClipboard(text) {
            if (window.clipboardData && window.clipboardData.setData) {
                // IE specific code path to prevent textarea being shown while dialog is visible.
                return window.clipboardData.setData('Text', text);
            } else if (
                document.queryCommandSupported &&
                document.queryCommandSupported('copy')
            ) {
                const textarea = document.createElement('textarea');
                textarea.textContent = text;
                textarea.style.position = 'fixed'; // Prevent scrolling to bottom of page in MS Edge.
                document.body.appendChild(textarea);
                textarea.select();
                try {
                    return document.execCommand('copy'); // Security exception may be thrown by some browsers.
                } catch (ex) {
                    console.warn('Copy to clipboard failed.', ex);
                    return false;
                } finally {
                    document.body.removeChild(textarea);
                }
            }
            return true;
        },
        handleListPanel(i, type = '') {
            const self = this;
            const index = i;
            if (type) {
                self.showList = type;
            } else {
                self.showList = index;
            }
        },
        onClickCopy(userId) {
            const self = this;
            this.copyToClipboard(userId);
            self.$Message.success(self.$t('balance_copy_success'));
        },
        viewAccount(userId) {
            window.open(
                `https://explorer.bytetrade.com/address.html?userId=${userId}`
            );
        },

        exportAccount(index) {
            const self = this;
            if (index === self.userId) {
                self.exportIndex = self.$store.state.currAccountIndex;
            } else {
                self.exportIndex = index;
            }
            self.maskView = true;
            self.exportDialog = true;
        },
        hideExportDialog() {
            const self = this;
            self.exportDialog = false;
            self.maskView = false;
        },
        rucAction(action) {
            const self = this;
            self.$router.push(`/${action}`);
        },
        changeInviter() {
            let inviter = "";
            let password = "";
            this.$Modal.confirm({
                loading: true,
                render: (h) => h('div', [
                    h('Input', {
                        props: {
                            value: password,
                            type: 'password',
                            placeholder: 'Please enter your Password...'
                        },
                        on: {
                            input: (val) => {
                                password = val;
                            }
                        }
                    }),
                    h('Input', {
                        props: {
                            value: inviter,
                            placeholder: 'Please enter your inviter...'
                        },
                        on: {
                            input: (val) => {
                                inviter = val;
                            }
                        }
                    })
                ]),
                okText: 'OK',
                cancelText: 'Cancel',
                onOk: async ()=>{
                    try {
                        const tr = await balance.getEmptyTransaction({ password });
                        const { data: { code } = {} } = await axios.post(`${settings.SERVER_PREFIX}/me`, {
                            cmd: 'updateUserInviter',
                            userid: this.$store.getters.currAccount.userid,
                            inviter,
                            transaction: JSON.stringify(tr),
                        });
                        if(code === 1){
                            this.$Message.error('Invalid Request');
                        } else if(code === 200300){
                            this.$Message.error('Inviter already exists');
                        } else if(code === 200301){
                            this.$Message.error('Inviter does not exist');
                        }
                        this.initUser();
                    } catch(e) {
                        console.error(e);
                    }
                    this.$Modal.remove();
                }
            })
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/common/header.js